import React from 'react'
import Spinner from '../../components/presentationals/Spinner'

const LinksByPlan = ({ data, wirelinePlanCount }) => {
  return (
    <div
      className='whitebox wow fadeInUp'
      data-wow-delay='.6s'
      data-wow-duration='0.7s'
    >
      <div className='subtitlebox'>
        <div className='subtitleboxChild'>{data.tileName}</div>
      </div>
      {/* <div className='d-none d-sm-block col-12'> */}
        <div className='row'>
          {wirelinePlanCount.loading ? (
            <Spinner />
          ) : (
            <div className='datatable earnings-table d-flex' data-cy='earnings-table'>
              <table className='table table-striped table-responsive'>
                <thead>
                  <tr role='row'>
                    <th className="justify-content-center" colSpan='1' style={{ fontWeight: 'bold' }}>
                      Plan Name
                    </th>
                    <th colSpan='1' style={{ fontWeight: 'bold' }}>
                      Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {wirelinePlanCount?.data?.content?.length ? (
                    <>
                    {wirelinePlanCount.data.content.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td colSpan='1'>{obj.kpi}</td>
                          <td>{obj.count}</td>
                        </tr>
                      )
                    })}
                    <tr>
                      <td style={{ fontWeight: 'bold' }}>TOTAL</td>
                      <td>{wirelinePlanCount.data.content.reduce((acc,curr) => acc+ parseInt(curr.count) , 0)}</td>
                    </tr>
                    </>
                  ) : (
                    //if the response is empty, show no data available
                    <tr>
                      <td colSpan={3}>no data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      {/* </div> */}
    </div>
  )
}

export default LinksByPlan
